module.exports = __webpack_public_path__ + "img/jiaofei-xianxing.d516964d.png";